import axiosInstance from "../api/authAPI";
import {
  CreateFormResponse,
  FetchFormListRequest,
  FetchFormListResponse,
} from "../types/formTypes";

export const createFormAPI = async (
  formData: FormData
): Promise<CreateFormResponse> => {
  try {
    const response = await axiosInstance.post("/form", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Form creation failed";
  }
};


export const updateFormAPI = async (
  formData: FormData
): Promise<CreateFormResponse> => {
  try {
    const response = await axiosInstance.post("/update-form", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Form updation failed";
  }
};

export const fetchFormList = async (
  params: FetchFormListRequest
): Promise<FetchFormListResponse> => {
  try {
    const response = await axiosInstance.get<FetchFormListResponse>(
      "/forms", // or your actual endpoint like "/forms"
      { params }
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to fetch form list";
  }
};
export const deleteForm = async (
  survey_version_id: number,
  survey_id: number
): Promise<FetchFormListResponse> => {
  try {
    const formData = new FormData();
    formData.append("survey_version_id", survey_version_id.toString()); // ✅ convert to string
    formData.append("survey_id", survey_id.toString()); // ✅ convert to string

    const response = await axiosInstance.post(`/delete-form`, formData);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Form deletion failed" };
  }
};

// get formDetail
export const getFormById = async (
  survey_version_id: number,
  survey_id: number
): Promise<CreateFormResponse> => {
  try {
    const formData = new FormData();
    formData.append("survey_version_id", survey_version_id.toString());
    formData.append("survey_id", survey_id.toString());
    const response = await axiosInstance.post(`/get-form-detail`, formData);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Failed to fetch form details" };
  }
};

// get submit survey by id
export const getSubmitSurveyId = async (id: number): Promise<CreateFormResponse> => {
  try {
    const response = await axiosInstance.get(`/get-submit-form-details/${id}`);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Survey deletion failed" };
  }
};